import { render, staticRenderFns } from "./Rule61ApplicationInstructions.vue?vue&type=template&id=20977227"
import script from "./Rule61ApplicationInstructions.vue?vue&type=script&lang=ts"
export * from "./Rule61ApplicationInstructions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports